class Profiling.AsyncJob
  constructor: ->
    _.extend(@, Backbone.Events)

  start: (jobName, params) =>
    @job = new ResqueJob
      url: "/profiling/dashboard/jobs/#{jobName}"
      data: params
      success: (results) =>
        @trigger('completed', results)
      error: =>
        @trigger('failed')
    @job.start()

  stop: ->
    @job.stop()
